//系统的通用配置功能
export default [
  {
    //虚拟电厂概况配置
    path: '/setPlantParams',
    name: 'setPlantParams',
    component: () => import('@/page/unitKanBan/setPlantParams.vue')
  },
  {
    // 用户管理模块
    path: '/userManager',
    name: 'userManager',
    component: () => import('@/page/userManager/userManager.vue')
  }, {
    // 用户管理模块
    path: '/newuserManager',
    name: 'newuserManager',
    component: () => import('@/page/userManager/newuserManager.vue')
  }, {
    //添加用户
    path: '/userConfig',
    name: 'userConfig',
    component: () => import('@/page/userConfig/userConfig.vue')
  }, { //角色管理
    path: '/roleManager',
    name: 'roleManager',
    component: () => import('@/page/roleManager/roleManager.vue')
  }, {
    //组织架构
    path: '/unitManage',
    name: 'unitManage',
    component: () => import('@/page/unitManage/unitManage.vue')
  }, {
    //组织架构
    path: '/base',
    name: 'base',
    component: () => import('@/page/unitManage/base.vue')
  }, {
    //设备管理
    path: '/virtualDevice',
    name: 'virtualDevice',
    component: () => import('@/page/unitManage/virtualDevice.vue')
  }, {
    //变量管理
    path: '/variableManage',
    name: 'variableManage',
    component: () => import('@/page/unitManage/variableManage.vue')
  }, {
    //web菜单配置
    path: '/webMenuConfig',
    name: 'webMenuConfig',
    component: () => import('@/page/menuConfig/webMenuConfig.vue')
    // component: () => import('@/page/abbNewPage/AppModuleRight.vue')
  }, {
    //app菜单配置（新）
    path: '/appMenu',
    name: 'appMenu',
    component: () => import('@/page/menuConfig/appMenuNew.vue')
    // component: () => import('@/page/abbNewPage/AppModuleRight.vue')
  }, {
    //小程序mini菜单配置
    path: '/miniMenu',
    name: 'miniMenu',
    component: () => import('@/page/menuConfig/miniMenu.vue')
    // component: () => import('@/page/abbNewPage/AppModuleRight.vue')
  }, {
    //app菜单配置
    path: '/appMenuConfig',
    name: 'appMenuConfig',
    component: () => import('@/page/menuConfig/appMenuConfig.vue')
  }, {
    //采集设备配置
    path: '/collectionList',
    name: 'collectionList',
    component: () => import('@/page/collectionConfig/collectionList.vue')
  }, {
    //生产制造看板
    path: '/shengchan',
    name: 'shengchan',
    component: () => import('@/page/unitKanBan/shengchan.vue')
  }, {
    //生产制造看板
    path: '/shengchan2',
    name: 'shengchan2',
    component: () => import('@/page/unitKanBan/shengchan2.vue')
  },]